import React, { Fragment, useEffect, useRef, useState } from 'react'
import { logoutFunction } from '../../_helpers'
import { IoLogOutOutline } from 'react-icons/io5'
import { MdOutlineMenu } from 'react-icons/md'
import { useDispatch } from 'react-redux'
import profileIcon from '../../public/images/profile.svg'
import { logout } from '../../Redux/userSlice'

export default function Header({ HeaderJSON, handleNavbar }) {
  const [openModel, setOpenModel] = useState(false)
  const dispatch = useDispatch()
  const dropDownRef = useRef(null)

  const handleLogout = () => {
    logoutFunction()
    dispatch(logout())
  }

  const toggleLogoutModal = () => {
    setOpenModel(!openModel)
  }

  useEffect(() => {
    const handleClickOutside = event => {
      if (dropDownRef.current && !dropDownRef.current.contains(event.target)) {
        setOpenModel(false)
      }
    }

    document.addEventListener('mousedown', handleClickOutside)
    return () => {
      document.removeEventListener('mousedown', handleClickOutside)
    }
  }, [])

  return (
    <Fragment>
      <div className='z-10 flex flex-shrink-0 h-16 bg-white border-b border-black shadow-md border-opacity-10'>
        <div className='flex items-center justify-between flex-1 px-6'>
          <div className='flex items-center space-x-4  px-3 py-2 rounded-md text-white'>
            <div className='bg-black px-3 py-2 rounded-md text-white lg:hidden block'>
              <MdOutlineMenu
                className='text-xl transition cursor-pointer'
                onClick={handleNavbar}
              />
            </div>
          </div>

          <div className='flex items-center space-x-6'>
            <div className='relative'>
              <img
                className='h-10 transition rounded-full cursor-pointer hover:ring-2 hover:ring-blue-300'
                src={profileIcon}
                alt='Profile'
                onClick={toggleLogoutModal}
              />
              {openModel && (
                <div
                  className='absolute right-0 w-48 mt-2 bg-white border border-gray-100 rounded-md shadow-lg'
                  ref={dropDownRef}
                >
                  <button
                    onClick={handleLogout}
                    className='block w-full px-4 py-2 text-sm text-left text-gray-700 transition hover:bg-gray-100 hover:text-red-600'
                  >
                    <IoLogOutOutline className='inline-block mr-2' />
                    Logout
                  </button>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  )
}
